/**
 * ============================================================
 * DIBAI 18K — Página de Tiendas
 * assets/tiendas-dibai.js  v1.0.0
 *
 * Navegación entre tiendas: clic en sidebar → muestra el
 * detalle correspondiente con animación de fade.
 * ============================================================
 */

(function () {
  'use strict';

  function initSection(root) {
    if (!root) return;

    const navBtns = root.querySelectorAll('[data-tnd-nav]');
    const stores  = root.querySelectorAll('[data-tnd-store]');

    if (!navBtns.length || !stores.length) return;

    function activate(index) {
      // Botones sidebar
      navBtns.forEach(btn => {
        const active = parseInt(btn.dataset.tndNav) === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      // Paneles de detalle
      stores.forEach(store => {
        const active = parseInt(store.dataset.tndStore) === index;
        store.classList.toggle('is-active', active);
        store.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      // Scroll suave al detalle en mobile
      if (window.innerWidth < 750) {
        const detail = root.querySelector('[data-tnd-detail]');
        detail?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    navBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        activate(parseInt(btn.dataset.tndNav));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.tiendas-dibai-wrapper').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('.tiendas-dibai-wrapper')
      || e.target.closest('.tiendas-dibai-wrapper');
    if (root) initSection(root);
  });

})();

/* ─────────────────────────────────────────
   LIGHTBOX — Tiendas DIBAI
   ───────────────────────────────────────── */
(function () {
  'use strict';

  function initLightbox(wrapper) {
    var lb       = document.querySelector('[data-tnd-lightbox]');
    if (!lb) return;
    var imgWrap  = lb.querySelector('[data-tnd-lb-img-wrap]');
    var counter  = lb.querySelector('[data-tnd-lb-counter]');
    var prevBtn  = lb.querySelector('[data-tnd-lb-prev]');
    var nextBtn  = lb.querySelector('[data-tnd-lb-next]');

    var images   = [];   // { src, alt }
    var current  = 0;
    var lastFocus = null;
    var startX   = 0;

    function buildImages(gallery) {
      var btns = gallery.querySelectorAll('[data-tnd-lb-open]');
      return Array.from(btns).map(function (btn) {
        return { src: btn.dataset.tndLbSrc, alt: btn.querySelector('img') ? btn.querySelector('img').alt : '' };
      });
    }

    function open(gallery, index) {
      images   = buildImages(gallery);
      current  = index;
      lastFocus = document.activeElement;
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      render();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      imgWrap.innerHTML = '<div class="tnd-lb__spinner"></div>';
      lastFocus && lastFocus.focus();
    }

    function go(dir) {
      current = ((current + dir) + images.length) % images.length;
      render();
    }

    function render() {
      if (!images.length) return;
      if (counter) counter.textContent = (current + 1) + ' / ' + images.length;
      imgWrap.innerHTML = '<div class="tnd-lb__spinner"></div>';
      var img = new Image();
      img.className = 'tnd-lb__img';
      img.alt = images[current].alt || '';
      img.onload = function () { imgWrap.innerHTML = ''; imgWrap.appendChild(img); };
      img.onerror = function () { imgWrap.innerHTML = '<p style="color:#fff;font-size:14px;">No se pudo cargar la imagen.</p>'; };
      img.src = images[current].src;
    }

    function onKey(e) {
      if (e.key === 'Escape')     close();
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft')  go(-1);
    }

    // Swipe
    lb.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend',   function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) go(diff > 0 ? 1 : -1);
    }, { passive: true });

    prevBtn && prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn && nextBtn.addEventListener('click', function () { go(1); });
    lb.querySelectorAll('[data-tnd-lb-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Abrir al hacer clic en cualquier botón de galería
    wrapper.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tnd-lb-open]');
      if (!btn) return;
      var gallery = btn.closest('[data-tnd-gallery]');
      if (!gallery) return;
      var idx = parseInt(btn.dataset.tndLbOpen || '0', 10);
      open(gallery, idx);
    });
  }

  function init() {
    document.querySelectorAll('.tiendas-dibai-wrapper').forEach(initLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target.querySelector('.tiendas-dibai-wrapper');
    if (w) initLightbox(w);
  });
})();
